import { Input, Modal, Space, Typography } from "antd";
import { Form, Formik } from "formik";
import React, { useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import * as Yup from "yup";

import { createAlbum, updateAlbumById } from "../../store/slices/albumSlice";

const { Title, Text } = Typography;

const AddAlbumPopup = ({ closePopup, item }) => {
  const history = useHistory();
  const formikRef = useRef(null);
  const handleCancel = () => {
    closePopup(false);
  };
  const dispatch = useDispatch();
  const [confirmLoading, setConfirmLoading] = useState(false);
  const initialValues = {
    title: item?.title ?? "",
    description: item?.description ?? "",
  };

  const validationSchema = Yup.object({
    title: Yup.string().required("Title is required"),
    description: Yup.string().required("Description is required"),
  });

  const onSubmit = (values) => {
    setConfirmLoading(true);

    if (item) {
      const data = {
        title: values.title,
        description: values.description,
        id: item.id,
      };

      dispatch(
        updateAlbumById(item.id, data, () => {
          setConfirmLoading(false);
          closePopup(false);
        })
      );
    } else {
      dispatch(
        createAlbum(values, (data) => {
          setConfirmLoading(false);
          closePopup(false);
          history.push(`/gallery/${data.id}`);
        })
      );
    }
  };

  return (
    <>
      <Modal
        title={item ? "Edit Album" : "Add Album"}
        open={true}
        confirmLoading={confirmLoading}
        onOk={() => {
          formikRef.current.submitForm();
        }}
        width={768}
        onCancel={handleCancel}
      >
        <>
          <Formik
            innerRef={formikRef}
            initialValues={initialValues}
            validationSchema={validationSchema}
            onSubmit={onSubmit}
          >
            {({ errors, touched, handleChange, values }) => {
              return (
                <Form>
                  <Space
                    direction="vertical"
                    style={{ width: "100%" }}
                    size={20}
                  >
                    <div>
                      <Title level={5}>Title *</Title>
                      <Input
                        placeholder="Enter album title"
                        name="title"
                        value={values.title}
                        onChange={handleChange}
                      />
                      {errors.title && touched.title ? (
                        <Text type="danger">{errors.title}</Text>
                      ) : null}
                    </div>

                    <div>
                      <Title level={5}>Description *</Title>
                      <Input.TextArea
                        placeholder="Enter album description"
                        name="description"
                        value={values.description}
                        onChange={handleChange}
                      />
                      {errors.description && touched.description ? (
                        <Text type="danger">{errors.description}</Text>
                      ) : null}
                    </div>
                  </Space>
                </Form>
              );
            }}
          </Formik>
        </>
      </Modal>
    </>
  );
};

export default AddAlbumPopup;
